import React from 'react';

const DocumentModal = ({ 
  show,
  mode, // 'add' | 'edit'
  user,
  documentForm,
  setDocumentForm,
  onClose,
  onSubmit
}) => {
  const isEdit = mode === 'edit';
  
  const title = user?.role === 'admin' 
    ? (isEdit ? 'Editar Plantilla Pública' : 'Agregar Plantilla Pública')
    : (isEdit ? 'Editar Tipo de Documento' : 'Agregar Tipo de Documento');

  const buttonText = user?.role === 'admin'
    ? (isEdit ? 'Guardar Cambios' : 'Crear Plantilla')
    : (isEdit ? 'Guardar Cambios' : 'Agregar Documento');

  const nameLabel = user?.role === 'admin' 
    ? 'Nombre de la Plantilla *' 
    : 'Nombre del Documento *';

  const namePlaceholder = user?.role === 'admin' 
    ? 'Ej: Oficio, Resolución, etc.' 
    : 'Ej: DNI, Recibo de Luz, etc.';

  const descriptionPlaceholder = user?.role === 'admin'
    ? 'Descripción de la plantilla que será visible para todos los usuarios'
    : 'Descripción detallada del tipo de documento';

  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
            />
          </div>
          <div className="modal-body">
            <form>
              <div className="mb-3">
                <label className="form-label">{nameLabel}</label>
                <input
                  type="text"
                  className="form-control"
                  value={documentForm.nombre}
                  onChange={(e) => setDocumentForm({...documentForm, nombre: e.target.value})}
                  placeholder={namePlaceholder}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Descripción *</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={documentForm.descripcion}
                  onChange={(e) => setDocumentForm({...documentForm, descripcion: e.target.value})}
                  placeholder={descriptionPlaceholder}
                />
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <div className="row w-100 g-2">
              <div className="col-6">
                <button 
                  type="button" 
                  className="btn btn-secondary w-100" 
                  onClick={onClose}
                >
                  Cancelar
                </button>
              </div>
              <div className="col-6">
                <button 
                  type="button" 
                  className="btn btn-primary w-100" 
                  onClick={onSubmit}
                >
                  {buttonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentModal;
